import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Empty, Typography } from 'antd';
// import Highcharts from 'highcharts/es-modules/masters/highcharts.src.js';
// import HighchartsReact from 'highcharts-react-official';

import {
  ASSET_CLASSES,
  PlayerAnalysisType,
  REAL_TIME_SCENARIO,
  selectors,
} from 'state';
import { AreaChart } from 'components';
import { formatters } from 'services';

const { Text } = Typography;

export type Props = {
  player: PlayerAnalysisType;
};

const PlayerPnLEvolutionTab: React.FC<Props> = ({ player }) => {
  const session = useSelector(selectors.activeSession);
  const repCcy = useSelector(
    selectors.currencyById(session.reporting_currency)
  );
  const playerData = useSelector(selectors.playerById(player.player_id));
  const isRealTime = session.scenario_type === REAL_TIME_SCENARIO;

  const playerReturnHistory = playerData.player_history.map((item, index) => ({
    x: isRealTime ? item.timestamp : index * session.frequency + 1,
    y: item.portfolio_return,
  }));
  const benchmarkReturnHistory = playerData.metrics.map((item, index) => ({
    x: isRealTime ? item.timestamp : index * session.frequency + 1,
    y: item.market_index_return,
  }));

  const xaxis = isRealTime
    ? undefined
    : {
        tooltip: {
          enabled: false,
        },
        labels: {
          formatter: function (value: unknown) {
            return `Day ${value}`;
          },
          show: false,
        },
      };

  return (
    <div>
      <AreaChart
        style={{ width: 550 }}
        title=""
        dataSeriesName="Benchmark"
        data={benchmarkReturnHistory}
        yaxisFormatter={formatters.percent1Digit}
        xaxis={xaxis}
        tooltipDateFormat={'d MMM HH:mm'}
        additionalLines={[
          { name: `${playerData.name}`, data: playerReturnHistory },
        ]}
      />
    </div>
  );
};

export default PlayerPnLEvolutionTab;
